(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    document.addEventListener(
    'click',
    async (event) => {
      const button = event.target.closest('[data-buy-now]');
      if (!button) return;

      // Product cards are wrapped in a link — don't open the product page
      event.preventDefault();
      event.stopPropagation();
      if (button.disabled) return;

      // Use the button's own form — form IDs are duplicated across product cards
      const form = button.closest('form');
      if (!form) return

      const formData = new FormData(form);
      const variantId = formData.get('id');
      const quantity = parseInt(formData.get('quantity'), 10) || 1;
      if (!variantId) return;

      // "Keep cart" off: checkout with only this product
      if (button.dataset.keepCart === 'false') {
        window.location.href = `/cart/${variantId}:${quantity}`;
        return;
      }

      button.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: formData,
        });
        if (!response.ok) {
          const error = await response.json();
          throw new Error(error.description || error.message);
        }
        window.location.href = '/checkout';
      } catch (error) {
        alert(error.message || 'Could not add this item to your cart.');
        button.removeAttribute('aria-busy');
      }
    },
    true
  );
  } catch(e) { console.error(e); }
})();

})();
